/* import __COLOCATED_TEMPLATE__ from './edge-split-table-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();